import { useContext } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectUserId } from '../../../store/user/userSlice'
import { ChatContent, ChatFilters } from '../../messages/components/DashboardChat'
import {
  AllButton,
  ExhibitorsButton,
  StaffButton,
  SpectatorButton,
} from '../../messages/components/FilterButtons'
import NewMessage from '../../messages/components/NewMessage'
import ChatStream from '../../messages/components/ChatStream'
import { HandleModalContext } from '../../../layout/mainlayout/MainLayout'
import { MODAL_CONSTS } from '../../../const/modal-const'
import ChatHOC from '../../messages/components/ChatHOC'
import FirebaseApp from '../../../services/firebaseApp'
import { httpsCallable } from 'firebase/functions'
import { selectedEvent as selectedEventGetter } from '../../../store/events/eventsSlice'
// Types
type Props = {
  eventId: string
}

const ManageClinicNOtherMessagesTab = (props: Props) => {
  const handleModalContext = useContext(HandleModalContext)
  const userId = useAppSelector(selectUserId)
  const selectedEvent = useAppSelector(selectedEventGetter)
  const notifyMessage = httpsCallable(FirebaseApp.functions, 'notifyMessage')

  return (
    <ChatHOC>
      <div className="flex flex-col w-full rounded-md px-4 bg-white pb-24">
        {userId ? (
          <ChatContent userId={userId} eventId={props.eventId}>
            <div className="h-[70vh] w-full rounded-md px-4 bg-white pb-24">
              <div className="h-14 w-full flex flex-row items-center justify-between py-10 border-b-[1px] border-[#122B461A]/[0.1]">
                <ChatFilters>
                  <AllButton />
                  <ExhibitorsButton />
                  <StaffButton />
                  <SpectatorButton />
                </ChatFilters>

                <div className="flex flex-row space-x-2">
                  <NewMessage
                    onClick={() => {
                      handleModalContext?.handleModal(true, MODAL_CONSTS.MEMBERS_EVENT_MODAL, {
                        eventId: props.eventId,
                      })
                    }}
                  />
                </div>
              </div>

              <ChatStream
                type="events"
                onSendMessage={(text, members) => {
                  if (userId === selectedEvent.Event?.owner) {
                    notifyMessage({
                      senderId: userId,
                      recipientsIds: members.filter((member) => member !== userId),
                      messageText: text,
                      eventId: props.eventId,
                    })
                  }
                }}
              />
            </div>
          </ChatContent>
        ) : (
          <></>
        )}
      </div>
    </ChatHOC>
  )
}

export default ManageClinicNOtherMessagesTab
